import { useDispatch, useSelector } from "react-redux";
import { Column } from "@stenajs-webui/core";
import { getNotificationsList, removeNotificationById } from "./redux/slice";
import { NotificationItem } from "../..//features/notification-center/NotificationItem";
import { ZIndex } from "@/lib/utils/ZIndexEnum";
import { useContext } from "react";
import {
  FeatureFlagsContext,
  FeatureFlagsContextType,
} from "@/config/featureFlags/FeatureFlagsContext";

export const NotificationCenter = () => {
  const notifications = useSelector(getNotificationsList);
  const dispatch = useDispatch();

  const onCloseClicked = (removeId: string) => {
    dispatch(removeNotificationById({ id: removeId }));
  };

  const { featureFlags } = useContext(
    FeatureFlagsContext
  ) as FeatureFlagsContextType;

  const renderNotificationCenter =
    featureFlags.agreement.useReportMessageSubscription;

  return renderNotificationCenter ? (
    <Column
      className={"notification-center"}
      zIndex={ZIndex.highest}
      position={"absolute"}
      right={"16px"}
      top={"48px"}
      gap={1}
    >
      {notifications.map((n) => (
        <NotificationItem
          key={n.id}
          subscriptionPayload={n}
          onClose={onCloseClicked}
        />
      ))}
    </Column>
  ) : null;
};
